import React from "react";

const About = () => {
  return (
    <div>
      <div className="container py-5">
        <h1 className="display-4">About us</h1>
        <p>
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Laboriosam
          fugiat eum corrupti aliquam eius ab odit, dolorem labore possimus
          iste!
        </p>
      </div>

      <section>
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <h2 className="display-2">Our Team</h2>
              <p>
                Lorem ipsum dolor, sit amet consectetur adipisicing elit. Omnis
                dolorem veritatis assumenda doloremque illum repudiandae ut
                magni rerum. Quis nemo esse quae id eius, assumenda aperiam
                perspiciatis adipisci voluptatibus impedit commodi voluptate
                perferendis dignissimos sequi illo incidunt amet accusamus
                beatae similique exercitationem. Impedit doloremque placeat
                tempora sit praesentium tempore temporibus illum, possimus neque
                suscipit rerum tenetur! Ea, reiciendis voluptas. At soluta
                maiores quibusdam incidunt iste voluptatibus perspiciatis
                repellat! Saepe quis similique ab minus impedit ipsam sit
                perferendis dolore officia sapiente. Architecto explicabo quam
                obcaecati eum rerum atque ipsam. Molestiae dolorem saepe harum
                iste labore magnam earum, natus itaque! Impedit, explicabo!
              </p>
              <p>
                Lorem ipsum dolor, sit amet consectetur adipisicing elit. Omnis
                dolorem veritatis assumenda doloremque illum repudiandae ut
                magni rerum. Quis nemo esse quae id eius, assumenda aperiam
                perspiciatis adipisci voluptatibus impedit commodi voluptate
                perferendis dignissimos sequi illo incidunt amet accusamus
                beatae similique exercitationem. Impedit doloremque placeat
                tempora sit praesentium tempore temporibus illum, possimus neque
                suscipit rerum tenetur! Ea, reiciendis voluptas. At soluta
                maiores quibusdam incidunt iste voluptatibus perspiciatis
                repellat! Saepe quis similique ab minus impedit ipsam sit
                perferendis dolore officia sapiente. Architecto explicabo quam
                obcaecati eum rerum atque ipsam. Molestiae dolorem saepe harum
                iste labore magnam earum, natus itaque! Impedit, explicabo!
              </p>
              <p>
                Lorem ipsum dolor, sit amet consectetur adipisicing elit. Omnis
                dolorem veritatis assumenda doloremque illum repudiandae ut
                magni rerum. Quis nemo esse quae id eius, assumenda aperiam
                perspiciatis adipisci voluptatibus impedit commodi voluptate
                perferendis dignissimos sequi illo incidunt amet accusamus
                beatae similique exercitationem. Impedit doloremque placeat
                tempora sit praesentium tempore temporibus illum, possimus neque
                suscipit rerum tenetur! Ea, reiciendis voluptas. At soluta
                maiores quibusdam incidunt iste voluptatibus perspiciatis
                repellat! Saepe quis similique ab minus impedit ipsam sit
                perferendis dolore officia sapiente. Architecto explicabo quam
                obcaecati eum rerum atque ipsam. Molestiae dolorem saepe harum
                iste labore magnam earum, natus itaque! Impedit, explicabo!
              </p>
            </div>
            <div className="col-md-6">
              <img
                className="img-fluid"
                src="https://images.pexels.com/photos/8483565/pexels-photo-8483565.jpeg"
                alt=""
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
